"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Influencer = _interopRequireDefault(require("@deosite/ui-entities/Influencer"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var __jsx = _react["default"].createElement;
var InfluencerBio = function InfluencerBio(props) {
  var _props$influencerData = props.influencerData,
    image = _props$influencerData.image,
    name = _props$influencerData.name,
    url = _props$influencerData.url,
    username = _props$influencerData.username,
    description = _props$influencerData.description;
  return __jsx(_Box["default"], {
    sx: {
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "neutral500",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "neutral500",
      pt: "s9",
      pb: "s9",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "80px",
      height: "80px",
      borderRadius: "80px",
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    minified: true,
    image: image
  })), __jsx(_Box["default"], {
    sx: {
      ml: "s8",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s"
    }
  }, name), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s_italic"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, "@" + username)))), __jsx(_Box["default"], {
    sx: {
      font: "base",
      mt: "s9"
    }
  }, description));
};
var _default = InfluencerBio;
exports["default"] = _default;